cb.define([], function() {
    var PC_pc_productbrandprolist_VM_Extend = {
        doAction: function(name, viewmodel) {
            if (this[name]) {
                this[name](viewmodel);
            }
        },
        init: function(viewmodel) {
            viewmodel.on('beforeBatchdelete', args => {
                let _data = viewmodel.get('pc_productbrandprolist').getRow(args.params.params.index)
                if (_data.sourcetype) {
                    cb.utils.alert('系统预制的属性不能删除', 'warning');
                    return false
                }
            })
        },
    }
    try {
        module.exports = PC_pc_productbrandprolist_VM_Extend;
    } catch (error) {
        // 当 类型 为 档案 的时候
    }
    return PC_pc_productbrandprolist_VM_Extend;
});


// WEBPACK FOOTER //
// ./src/client/business/PC/PC_pc_productbrandprolist_VM.Extend.js